import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface SyncEmsListPricesInput {
    orderId: string;
}

interface SyncEmsListPricesResponse {
    updatedCount: number;
}

const syncEmsListPrices = async (
    data: SyncEmsListPricesInput,
    sessionId: string | null,
): Promise<SyncEmsListPricesResponse> => {
    const { data: response } = await axios.post<SyncEmsListPricesResponse>(
        `${API_URL}/order/ems/sync-prices`,
        data,
        {
            headers: {
                Authorization: sessionId,
            },
        },
    );
    return response;
};

export const useSyncEmsListPrices = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: SyncEmsListPricesInput) =>
            syncEmsListPrices(data, sessionContext?.sessionId ?? null),
    });
};
